<template>
  <three-panel-condition
    :target="target"
    :conditions="conditions"
    :prefix="prefix"
    :data="data"
    :loading="loading"
    :title="title"
    :label-help="t('Apple device tracking limitations may cause incorrect detection of some iPhone models.')"
    :name="name"
    @close="emit('close')"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import ThreePanelCondition from './three-panel-condition/three-panel-condition.vue';
import { useFlowThreePanelDictionaryCondition } from './useFlowThreePanelDictionaryCondition';

defineProps<{
  target?: unknown;
  conditions: Record<string, unknown>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const { data, loading, prefix, title, name } = useFlowThreePanelDictionaryCondition({
  apiKey: 'brands-v2',
  prefix: 'brand',
  title: t('Brand and model'),
  name: t('Brands'),
});
</script>

<style lang="scss"></style>
